import { Model } from 'ng2-app/modules/shared/models/model.class';

export class Document extends Model<Document> {

    activityId: number;
    aggregatorName: string;
    borrowerId: number;
    category: string;
    checked?: boolean;
    created: Date;
    dealId?: number;
    deleted: Date;
    deletedBy: string;
    filename: string;
    id: number;
    lenderId: number;
    lenderUserId: number;
    mimetype: string;
    modified: Date;
    months: string[];
    scanStatus: null | 'CLEAN' | 'PENDING' | 'INFECTED';
    size: number;
    title: string;
    uploadedBy: string;
    years: string[];

    fillable(): string[] {
        return [
            'activityId',
            'aggregatorName',
            'borrowerId',
            'category',
            'created',
            'dealId',
            'deleted',
            'deletedBy',
            'filename',
            'id',
            'lenderId',
            'lenderUserId',
            'mimetype',
            'modified',
            'months',
            'scanStatus',
            'size',
            'title',
            'uploadedBy',
            'years',
        ];
    }

    serializeable(): string[] {
        return this.fillable();
    }
}
